const cards = [
  {
    icon: 'ri-gamepad-line',
    name: 'ポケモンカードゲーム',
    desc: 'ピカチュウ・リザードンなど人気カードを高価買取。最新弾から旧裏まで幅広く対応。',
    tag: '高松 ポケモンカード',
    color: 'bg-yellow-50',
    iconColor: 'text-yellow-600',
    iconBg: 'bg-yellow-100',
  },
  {
    icon: 'ri-sword-line',
    name: 'ワンピースカードゲーム',
    desc: 'ルフィ・ゾロなど人気キャラのカードを買取・販売。シングルカードも対応。',
    tag: '高松 ワンピースカード',
    color: 'bg-red-50',
    iconColor: 'text-red-600',
    iconBg: 'bg-red-100',
  },
  {
    icon: 'ri-shield-star-line',
    name: 'ユニオンアリーナ',
    desc: '人気アニメキャラが集結するTCG。レアカードの買取・販売を行っています。',
    tag: '高松 ユニオンアリーナ',
    color: 'bg-violet-50',
    iconColor: 'text-violet-600',
    iconBg: 'bg-violet-100',
  },
  {
    icon: 'ri-fire-line',
    name: 'デュエルマスターズ',
    desc: '長年愛されるTCG。旧弾・新弾問わず幅広く買取・販売しています。',
    tag: '高松 デュエルマスターズ',
    color: 'bg-orange-50',
    iconColor: 'text-orange-600',
    iconBg: 'bg-orange-100',
  },
  {
    icon: 'ri-heart-line',
    name: 'ヴァイスシュバルツ',
    desc: 'アニメ・ゲームキャラのTCG。人気タイトルのカードを高価買取。',
    tag: '高松 ヴァイスシュバルツ',
    color: 'bg-pink-50',
    iconColor: 'text-pink-600',
    iconBg: 'bg-pink-100',
  },
];

export default function MangakuCards() {
  return (
    <section id="cards" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col items-center text-center mb-16">
          <span className="text-xs tracking-[0.3em] text-red-500 font-medium uppercase mb-3">Trading Cards</span>
          <h2 className="text-4xl md:text-5xl font-serif text-gray-900 mb-4">取扱カードゲーム</h2>
          <div className="w-16 h-0.5 bg-red-300/50 mx-auto mb-6"></div>
          <p className="text-sm text-gray-500 max-w-xl leading-relaxed">
            香川県高松市の<strong className="text-gray-700">ポケモンカード専門店</strong>として、
            人気TCGの買取・販売を行っています。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <div key={card.name} className={`${card.color} rounded-2xl p-7 flex flex-col gap-4`}>
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 flex items-center justify-center ${card.iconBg} rounded-full`}>
                  <i className={`${card.icon} ${card.iconColor} text-lg`}></i>
                </div>
                <span className="text-xs text-gray-400 bg-white/70 px-2.5 py-1 rounded-full">{card.tag}</span>
              </div>
              <div>
                <h3 className="text-base font-semibold text-gray-800 mb-2">{card.name}</h3>
                <p className="text-xs text-gray-500 leading-relaxed">{card.desc}</p>
              </div>
              <div className="flex gap-2 mt-auto">
                <span className="text-xs bg-white/80 text-gray-600 px-3 py-1 rounded-full">買取</span>
                <span className="text-xs bg-white/80 text-gray-600 px-3 py-1 rounded-full">販売</span>
              </div>
            </div>
          ))}
          <div className="bg-gray-50 rounded-2xl p-7 flex flex-col items-center justify-center gap-3 text-center border-2 border-dashed border-gray-200">
            <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full">
              <i className="ri-add-line text-gray-400 text-lg"></i>
            </div>
            <p className="text-sm font-medium text-gray-500">その他のカードも<br />お気軽にご相談ください</p>
          </div>
        </div>
      </div>
    </section>
  );
}
